import React from "react"

import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import SupportNavigation from "../components/support_navigation"
import SupportArticleList from "../components/support_article_list"

const SupportArticlesPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Support Articles" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <SupportNavigation location={location} />
      <SupportArticleList />
    </Layout>
  )
}

export default SupportArticlesPage
